module.exports = __webpack_public_path__ + "img/20220107_080836 (1).54de668c.jpg";